/* eslint-disable unicorn/filename-case */
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { ToolCta as CTA } from '../../../components/toolcta/ToolCta'
import { html } from '../../../utils/htmlParser'
import { isNotNull } from '../../../utils/nonNull'
import { NewsTwoColCtaFragment } from '@gql'

export type FullScreenCtaProps = {
  data: NewsTwoColCtaFragment[]
}

const StyledCTA = styled(CTA)`
  margin-top: ${props => props.theme.typography.pxToRem(100)};
  padding-left: ${props => props.theme.typography.pxToRem(20)};
  padding-right: ${props => props.theme.typography.pxToRem(25)};
  position: relative;

  ${props => props.theme.breakpoints.up('md')} {
    padding: 0;
  }

  div[class^="StyledToolCta__StyledTriangleBox"] {
    right: ${props => props.theme.typography.pxToRem(25)};

    ${props => props.theme.breakpoints.up('md')} {
      right: 0;
    }
  }
`

export const TwoColCTA: React.FC<PropsWithChildren<FullScreenCtaProps>> = ({ data }) => {
  if (!data[0] || data[0].__typename !== 'twoColumnCta_BlockType') {
    return null
  }

  const { twoColRightCtaTitle, twoColRightCtaSubtext, rightColumnCtaButton, twoColLeftCtaTitle, twoColLeftCtaSubtext, leftColumnCtaButton } = data[0]
  const hasLeftColumn = Boolean(twoColLeftCtaTitle || twoColLeftCtaSubtext || leftColumnCtaButton)
  const hasRightColumn = Boolean(twoColRightCtaTitle || twoColRightCtaSubtext || rightColumnCtaButton)

  return (
    <StyledCTA>
      {hasLeftColumn && (
        <CTA item>
          {twoColLeftCtaTitle && (
            <CTA title>{twoColLeftCtaTitle}</CTA>
          )}
          {twoColLeftCtaSubtext && (
            <CTA subText>{html(twoColLeftCtaSubtext)}</CTA>
          )}
          {leftColumnCtaButton && leftColumnCtaButton.__typename === 'linkField_Link' && isNotNull(leftColumnCtaButton.url) && isNotNull(leftColumnCtaButton.customText) && (
            <CTA cta href={leftColumnCtaButton.url} target={leftColumnCtaButton.target === '_blank' ? '_blank' : '_self'}>{html(leftColumnCtaButton.customText)}</CTA>
          )}
        </CTA>
      )}
      {hasRightColumn && (
        <CTA item>
          {twoColRightCtaTitle && (
            <CTA title>{twoColRightCtaTitle}</CTA>
          )}
          {twoColRightCtaSubtext && (
            <CTA subText>{(html(twoColRightCtaSubtext))}</CTA>
          )}
          {rightColumnCtaButton && rightColumnCtaButton.__typename === 'linkField_Link' && isNotNull(rightColumnCtaButton.url) && isNotNull(rightColumnCtaButton.customText) && (
            <CTA cta href={rightColumnCtaButton.url} target={rightColumnCtaButton.target === '_blank' ? '_blank' : '_self'}>{html(rightColumnCtaButton.customText)}</CTA>
          )}
        </CTA>
      )}
    </StyledCTA>
  )
}
